import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Slider } from 'antd';

import { SectionHeading, SliderWrapper } from '../../styles';

const marks = {
  1: 'Thin',
  2: 'Default',
  4: 'Bold',
  6: 'Heavy',
};

const BoundaryWidth = ({ value = 2, onChange }) => (
  <Fragment>
    <SectionHeading>Boundary Width</SectionHeading>
    <p>
      Adjust the thickness of boundary outlines on the map.
    </p>
    <SliderWrapper>
      <Slider
        min={1}
        max={6}
        step={1}
        marks={marks}
        value={value}
        onChange={onChange}
      />
    </SliderWrapper>
  </Fragment>
);

BoundaryWidth.propTypes = {
  value: PropTypes.number,
  onChange: PropTypes.func.isRequired,
};

export default React.memo(BoundaryWidth);
